import axios from 'axios';

export function getLocations(filter) {
  return axios(`${process.env.REACT_APP_LOCALISATION_API_URL}/FR/${filter}`);
}

export default { getLocations };
